<!--
 * @Author: liuxiaoyan
 * @Date: 2021-10-11 16:30:23
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2021-11-30 15:03:09
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
-->
<template>
  <div class="mall-share">
    <img src="https://image.xiaomaiketang.com/xm/2mKEcDhcQy.png" alt="">
    <div class="tip">由小麦助教提供技术支持</div>
  </div>
</template>

<script>
import WechatApi from '@/core/wechatApi';
import User from "@/core/user";

export default {
  data() {
    return {
      banner: '',
      instName: '',
    };
  },

  methods: {
    doShare() {
      WechatApi.doWapShare({
        title: `${this.instName}有购课商城啦！`,
        desc: '线上购课，微信支付，免去排队烦恼，快来看看~~',
        linkUrl: location.origin + location.pathname + '#/mall/buyer?appid=' + User.appId() + '&mallInstId=' + this.instId,
        imgUrl: this.banner || 'https://image.xiaomaiketang.com/xm/fpnxF7Gbmt.png',
      });
       wx.miniProgram.postMessage({ data: {
        title: `${this.instName}有购课商城啦！`,
        desc: '线上购课，微信支付，免去排队烦恼，快来看看~~',
        linkUrl: location.origin + location.pathname + '#/mall/buyer?appid=' + User.appId() + '&mallInstId=' + this.instId,
        imgUrl: this.banner || 'https://image.xiaomaiketang.com/xm/fpnxF7Gbmt.png',
      } })
    }
  },

  mounted() {
    this.banner = decodeURIComponent(window.getParameterByName('banner'));
    this.instName = window.getParameterByName('instName');
    this.instId = window.getParameterByName('mallInstId');
    this.doShare();
  },
}
</script>

<style lang="less">
  .mall-share {
    position: relative;
    width: 100%;
    height: 100%;
    img {
      position: absolute;
      width: 2.72rem;
      height: 3.82rem;
      top: 0.8rem;
      right: 0.8rem;
    }
    .tip {
      font-size: 0.28rem;
      color: #999;
      line-height: 0.4rem;
      position: absolute;
      bottom: 0.24rem;
      left: 50%;
      transform: translateX(-50%);
    }
  }
</style>


// WEBPACK FOOTER //
// src/module/mall/MallShare.vue